import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, Alert, Button,
} from '@mui/material';
import { initiateBookRequestApi } from '../../api/books';

const emptyRequestForm = { project_name: '', expected_price_per_book: '', minimum_value_per_publisher: '' };

export default function InitiateRequestDialog({ open, onClose, selectedIds, onSuccess }) {
  const [requestForm, setRequestForm] = useState(emptyRequestForm);
  const [submitting, setSubmitting] = useState(false);
  const [requestError, setRequestError] = useState('');

  const handleClose = () => {
    if (submitting) return;
    setRequestForm(emptyRequestForm);
    setRequestError('');
    onClose();
  };

  const handleSubmitRequest = async () => {
    setRequestError('');
    if (!requestForm.project_name) {
      setRequestError('Project Name is required.');
      return;
    }
    setSubmitting(true);
    try {
      await initiateBookRequestApi({
        ...requestForm,
        expected_price_per_book: requestForm.expected_price_per_book || 'NA',
        minimum_value_per_publisher: requestForm.minimum_value_per_publisher || 'NA',
        book_ids: selectedIds,
      });
      setRequestForm(emptyRequestForm);
      onSuccess('Your request has been submitted. The admin has been notified.');
    } catch (err) {
      const data = err.response?.data;
      const msg = (data && (data.detail || Object.values(data)[0]?.[0])) || 'Failed to submit request.';
      setRequestError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Initiate Request ({selectedIds.length} book{selectedIds.length === 1 ? '' : 's'} selected)</DialogTitle>
      <DialogContent dividers>
        {requestError && <Alert severity="error" sx={{ mb: 2 }}>{requestError}</Alert>}
        <TextField
          fullWidth label="Project Name" margin="normal" required
          value={requestForm.project_name}
          onChange={(e) => setRequestForm({ ...requestForm, project_name: e.target.value })}
        />
        <TextField
          fullWidth label="Expected Price per Book" type="number" margin="normal"
          placeholder="NA"
          helperText="Leave blank to submit as NA"
          value={requestForm.expected_price_per_book}
          onChange={(e) => setRequestForm({ ...requestForm, expected_price_per_book: e.target.value })}
        />
        <TextField
          fullWidth label="Minimum Value per Publisher" type="number" margin="normal"
          placeholder="NA"
          helperText="Leave blank to submit as NA"
          value={requestForm.minimum_value_per_publisher}
          onChange={(e) => setRequestForm({ ...requestForm, minimum_value_per_publisher: e.target.value })}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
        <Button onClick={handleSubmitRequest} variant="contained" disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
